<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>AI Config - Code Assessment</h1>

        <!-- Success/Error Messages -->
        @if (successMessage) {
<div class="alert alert-success">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
        </div>
}

        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>
}

        @if (loading) {
      <app-ai-config-skeleton></app-ai-config-skeleton>
      }

        <!-- Tabs -->
        @if (!loading) {
<mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">

          <!-- Tab 1: AI Assessments Settings -->
          <mat-tab label="Settings">
            <div style="padding: 20px;">
              <p class="text-muted">Configure AI-powered modernization assessments with dimension-specific prompts</p>

              @if (assessmentSettings && !editingAssessmentSettings) {
<div class="card" style="margin-bottom: 20px;">
                <div class="card-body">
                  <h5>Current Assessment Settings (Version {{ assessmentSettings.version }})</h5>
                  <table class="table">
                    <tbody>
                      <tr>
                        <th>Connection:</th>
                        <td>{{ assessmentSettings.connection.name }}</td>
                      </tr>
                      <tr>
                        <th>Azure DevOps Base URL:</th>
                        <td>{{ assessmentSettings.azureDevOpsBaseUrl }}</td>
                      </tr>
                      <tr>
                        <th>PAT KeyVault Secret:</th>
                        <td>{{ assessmentSettings.keyVaultSecretNameForPat }}</td>
                      </tr>
                      <tr>
                        <th>Polling Interval:</th>
                        <td>{{ assessmentSettings.pollingIntervalSeconds }} seconds</td>
                      </tr>
                      <tr>
                        <th>Max File Size:</th>
                        <td>{{ (assessmentSettings.maxFileSizeBytes / 1024 / 1024).toFixed(2) }} MB</td>
                      </tr>
                      <tr>
                        <th>Max Chunk Size:</th>
                        <td>{{ assessmentSettings.maxContentCharsPerDimensionChunk | number }} chars (~{{ (assessmentSettings.maxContentCharsPerDimensionChunk / 4000).toFixed(0) }}K tokens)</td>
                      </tr>
                      <tr>
                        <th>Status:</th>
                        <td><span class="badge bg-success">Active</span></td>
                      </tr>
                    </tbody>
                  </table>
                  
                  <div class="d-flex justify-content-between align-items-center">
                    <button type="button" class="btn btn-primary no-arrow" (click)="startEditAssessmentSettings()">
                      Edit Settings
                    </button>
                    <button type="button" class="btn btn-outline-secondary no-arrow" (click)="toggleVersionHistory()">
                      <i class="bi bi-clock-history"></i> {{ showVersionHistory ? 'Hide' : 'Show' }} Version History
                    </button>
                  </div>
                </div>
              </div>
}

              <!-- Version History -->
              @if (showVersionHistory && assessmentVersions.length > 0) {
<div class="card" style="margin-bottom: 20px;">
                <div class="card-body">
                  <h5>Version History</h5>
                  <p class="text-muted">View and activate previous versions</p>
                  
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>Version</th>
                          <th>Created</th>
                          <th>Created By</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (version of assessmentVersions; track version) {
<tr>
                          <td><strong>v{{ version.version }}</strong></td>
                          <td>{{ version.createdAt | utcDate:'short' }}</td>
                          <td>{{ version.createdByUserId || 'System' }}</td>
                          <td>
                            @if (version.isActive) {
<span class="badge bg-success">Active</span>
}
                            @if (!version.isActive) {
<span class="badge bg-secondary">Inactive</span>
}
                          </td>
                          <td>
                            @if (!version.isActive) {
<button 
                                    type="button" 
                                    class="btn btn-sm no-arrow" 
                                    (click)="activateVersion(version.id)"
                                    [disabled]="saving">
                              <i class="bi bi-arrow-counterclockwise"></i> Activate
                            </button>
}
                            @if (version.isActive) {
<span class="text-muted">Currently Active</span>
}
                          </td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
}

              @if (!assessmentSettings && !editingAssessmentSettings) {
<div class="alert alert-warning">
                No assessment settings configured.
                <br>
                <button type="button" class="btn btn-primary no-arrow" (click)="startEditAssessmentSettings()" 
                        [disabled]="connections.length === 0" style="margin-top: 10px;">
                  Configure Assessment Settings
                </button>
                @if (connections.length === 0) {
<p class="text-danger" style="margin-top: 10px;">
                  Please create at least one connection first.
                </p>
}
              </div>
}

              <!-- Assessment Settings Edit Form -->
              @if (editingAssessmentSettings) {
<div class="card" style="margin-bottom: 20px;">
                <div class="card-body">
                  <h5>Configure AI Assessment Settings</h5>

                  <div class="row">
                    @if (editingAssessmentSettings.version > 0) {
<div class="col-md-6">
                      <div class="form-group">
                        <label>Version</label>
                        <input type="text" class="form-control" [value]="editingAssessmentSettings.version"
                               readonly disabled style="background-color: #e9ecef;">
                        <small class="form-text text-muted">Version is auto-incremented when saved</small>
                      </div>
                    </div>
}
                  </div>

                  <div class="form-group">
                    <label>Connection <span class="text-danger">*</span></label>
                    <select class="form-control" [(ngModel)]="editingAssessmentSettings.aiConnectionId" [ngModelOptions]="{standalone: true}">
                      <option [value]="0">-- Select Connection --</option>
                      @for (conn of connections; track conn) {
<option [value]="conn.id">{{ conn.name }}</option>
}
                    </select>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Azure DevOps Base URL <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="editingAssessmentSettings.azureDevOpsBaseUrl"
                               placeholder="https://dev.azure.com/yourorg" [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>PAT KeyVault Secret Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="editingAssessmentSettings.keyVaultSecretNameForPat"
                               placeholder="AzureDevOpsPAT" [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Polling Interval (seconds)</label>
                        <input type="number" class="form-control" [(ngModel)]="editingAssessmentSettings.pollingIntervalSeconds"
                               [ngModelOptions]="{standalone: true}">
                        <small class="text-muted">How often to check for pending assessment jobs</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Max File Size (bytes)</label>
                        <input type="number" class="form-control" [(ngModel)]="editingAssessmentSettings.maxFileSizeBytes"
                               [ngModelOptions]="{standalone: true}">
                        <small class="text-muted">Files larger than this will be truncated</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Max Chunk Size (chars per dimension)</label>
                        <input type="number" class="form-control" [(ngModel)]="editingAssessmentSettings.maxContentCharsPerDimensionChunk"
                               [ngModelOptions]="{standalone: true}">
                        <small class="text-muted">Large dimensions are split into multiple chunks, assessed in parallel, and synthesized. Default: 150000 (~37K tokens).</small>
                      </div>
                    </div>
                  </div>

                  <hr>
                  <h6 class="mt-3">Dimension Prompts</h6>
                  <p class="text-muted">Configure AI prompts for each assessment dimension</p>

                  <mat-accordion>
                    <!-- CI/CD Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>CI/CD Pipeline Enabled</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.cicdPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter CI/CD assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- Authentication Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Authentication & Authorization</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.authPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter authentication assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- Code Refactor Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Code Refactor</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.codePrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter code refactor assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- System Dependencies Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>System Dependencies</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.dependenciesPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter dependencies assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- Hosting Platform Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Hosting Platform</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.hostingPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter hosting platform assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- API Usage Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>API Usage</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.apiPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter API usage assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- App Containerization Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>App Containerization</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.containerPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter containerization assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- Application Testing Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Application Testing</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.testingPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter testing assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- App Deployed to Production Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>App Deployed to Production</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.productionPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter production deployment assessment prompt..."></textarea>
                      </div>
                    </mat-expansion-panel>

                    <!-- Database Prompt — disabled, dimension excluded from assessment and scoring -->
                    <!--
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Database</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.databasePrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter database assessment prompt..."></textarea>
                        <small class="text-muted">Evaluates database technologies, SQL/stored procedures, migrations and ORM usage</small>
                      </div>
                    </mat-expansion-panel>
                    -->

                    <!-- Master Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Master Assessment Prompt</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.masterPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter master assessment prompt..."></textarea>
                        <small class="text-muted">Overall instructions and scoring rubric</small>
                      </div>
                    </mat-expansion-panel>

                    <!-- Additional Details Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Additional Recommendations, Assumptions and Dependencies Prompt</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.additionalDetailsPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter additional details prompt..."></textarea>
                        <small class="text-muted">Prompt for generating modernization scope recommendations and identified assumptions/dependencies</small>
                      </div>
                    </mat-expansion-panel>

                    <!-- Lightweight Code Validation Prompt -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>Lightweight Code Validation Prompt</mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="form-group">
                        <textarea class="form-control" rows="8" [(ngModel)]="editingAssessmentSettings.lightweightCodeValidationPrompt"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="Enter lightweight code validation prompt..."></textarea>
                        <small class="text-muted">Instructions for metadata-only repository validation and CMDB/code signal comparison</small>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>

                  <div style="display: flex; justify-content: space-between; margin-top: 20px;">
                    <button type="button" class="btn btn-primary no-arrow" 
                            (click)="saveFeatureSettings(AiFeature.AIAssessments)" [disabled]="saving">
                      @if (saving) {
<mat-spinner diameter="20" style="display: inline-block; margin-right: 5px;"></mat-spinner>
}
                      {{ saving ? 'Saving...' : 'Save Settings' }}
                    </button>
                    <button type="button" class="btn btn-secondary no-arrow" 
                            (click)="cancelEditFeatureSettings(AiFeature.AIAssessments)" [disabled]="saving">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
}
            </div>
          </mat-tab>
          
          <!-- Bulk lightweight validation -->
          <mat-tab label="Bulk Code Validation">
            <div style="padding: 20px;">
              <app-bulk-code-validation></app-bulk-code-validation>
            </div>
          </mat-tab>

          <!-- Job History -->
          <mat-tab label="Assesments Job History">
            <div style="padding: 20px;">

              <p class="text-muted">View all AI code assessment jobs and their results</p>

              @if (jobHistoryLoading) {
<app-ai-config-job-history-skeleton></app-ai-config-job-history-skeleton>
}

              @if (!jobHistoryLoading && jobHistory.length === 0) {
<div class="alert alert-info">
                <mat-icon>info</mat-icon>
                No assessment jobs found. Start an assessment to see history.
              </div>
}

              @if (!jobHistoryLoading && jobHistory.length > 0) {
<div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Job ID</th>
                          <th>Type</th>
                          <th>Repository</th>
                          <th>Branch</th>
                          <th>Status</th>
                          <th>Requested By</th>
                          <th>Started</th>
                          <th>Duration</th>
                          <th>Tokens</th>
                          <th>Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (job of jobHistory; track job) {
<tr>
                          <td>{{ job.id }}</td>
                          <td><span class="badge badge-secondary">{{ getJobTypeLabel(job) }}</span></td>
                          <td>
                            @if (job.trackedBusinessApplicationId) {
                              <a
                                [routerLink]="['/assessment', job.trackedBusinessApplicationId]"
                                [title]="'Open application modernization assessment for ' + job.repositoryUrl">
                                {{ truncateUrl(job.repositoryUrl) }}
                              </a>
                            } @else {
                              <span [title]="job.repositoryUrl">{{ truncateUrl(job.repositoryUrl) }}</span>
                            }
                          </td>
                          <td>{{ job.branch }}</td>
                          <td>
                            <span [class]="'badge ' + getJobStatusBadgeClass(getJobStatusText(job.status))">
                              {{ getJobStatusText(job.status) }}
                            </span>
                            @if (isJobRateLimited(job)) {
                              <div class="text-warning" style="margin-top: 4px; font-size: 12px; line-height: 1.3;">
                                <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: text-bottom;">schedule</mat-icon>
                                GitHub rate limited until {{ job.rateLimitedUntil | utcDate:'short' }}. It will resume automatically.
                              </div>
                            }
                          </td>
                          <td>{{ job.requestedByEmail || '-' }}</td>
                          <td>{{ job.createdAt | utcDate:'short' }}</td>
                          <td>{{ formatJobDuration(job) }}</td>
                          <td>
                            @if (job.totalTokens && job.totalTokens > 0) {
<div style="font-size: 11px; line-height: 1.4;">
                              <div title="Prompt tokens">
                                <span class="badge badge-secondary"><strong>P:</strong>&nbsp;{{ formatTokenCount(job.totalPromptTokens) }}</span>
                              </div>
                              <div title="Completion tokens" style="margin-top: 2px;">
                                <span class="badge badge-secondary"><strong>C:</strong>&nbsp;{{ formatTokenCount(job.totalCompletionTokens) }}</span>
                              </div>
                              <div title="Total tokens" style="margin-top: 2px;">
                                <span class="badge badge-success"><strong>T:</strong>&nbsp;{{ formatTokenCount(job.totalTokens) }}</span>
                              </div>
                            </div>
}
                            @if (!job.totalTokens || job.totalTokens === 0) {
<small>-</small>
}
                          </td>
                          <td>
                            <div class="job-action-buttons">
                              @if (getJobStatusText(job.status) === 'Completed') {
<button
                                      type="button" class="button small job-action-btn no-arrow"
                                      (click)="viewJobDetails(job)">
                                View Details
                              </button>
<button 
                                      type="button" class="button small job-action-btn no-arrow" 
                                      (click)="viewResultJson(job)">
                                JSON Result
                              </button>
}
                              @if (job.errorMessage) {
<span class="text-danger" [title]="job.errorMessage">
                                <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle;">error_outline</mat-icon>
                                {{ job.errorMessage.length > 40 ? job.errorMessage.substring(0, 40) + '...' : job.errorMessage }}
                              </span>
}
                              @if (!job.errorMessage && getJobStatusText(job.status) === 'Running') {
<button
                                      type="button" class="button small job-action-btn no-arrow"
                                      (click)="viewJobDetails(job)">
                                View Details
                              </button>
}
                              @if (!job.errorMessage && getJobStatusText(job.status) === 'Pending') {
<button
                                      type="button" class="button small job-action-btn no-arrow"
                                      (click)="viewJobDetails(job)">
                                View Details
                              </button>
}
                            </div>
                          </td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>

                  <mat-paginator #jobHistoryPaginator
                    [length]="jobHistoryTotalCount"
                    [pageSize]="jobHistoryPageSize"
                    [pageIndex]="jobHistoryPage - 1"
                    [pageSizeOptions]="[10, 20, 50, 100]"
                    [showFirstLastButtons]="true"
                    (page)="onJobHistoryPageChange($event)">
                  </mat-paginator>
                </div>
              </div>
}
            </div>
          </mat-tab>

        </mat-tab-group>
}
      </div>
    </div>
  </section>
</main>
